<template>
  <div class="comtainer-main">
    <div class="bg-color">
        <img class="home-ico" :src="require('@/assets/images/home.png')" @click="openHome" alt="">
    </div>
    <div class="user-info">
        <div class="box-user-info">
            <img class="user-img" :src="userInfo.avatar?userInfo.avatar:headPortrait" alt="">
            <!-- <div class="user-name"> 小王</div>
            <div class="user-message">性别：<span>男</span> &nbsp;&nbsp;&nbsp;年龄：<span>29岁</span></div> -->
            <div class="user-name"><span v-if="userToken">{{userInfo.nickname}}</span><span v-else @click="loginBtn">立即登录</span>&nbsp;&nbsp;<span class="sex" v-if="userToken&&userInfo.sex">性别：{{userInfo.sex}}</span></div>
            <div class="is-login" v-if="!userToken">你当前还未登录</div>
        </div>
    </div>
   <div class="van-doc-demo-block__card">
        <div role="button" tabindex="0" class="van-cell van-cell--clickable" @click="openBalance">
            <div class="van-cell__title">
                <span>我的余额</span>
            </div>
            <span class="user-money" v-if="userToken">{{personal.userMoney}}&nbsp;&nbsp;</span>
            <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
        
        <div role="button" tabindex="0" class="van-cell van-cell--clickable" @click="openConsumption">
            <div class="van-cell__title">
                <span>消费记录</span>
            </div>
            <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
        <div role="button" tabindex="0" class="van-cell van-cell--clickable" @click="openCouponList">
            <div class="van-cell__title">
                <span>我的优惠券</span>
            </div>
            <span class="user-money" v-if="userToken">{{couponCount}}张待用&nbsp;&nbsp;</span>
            <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
        <div role="button" tabindex="0" class="van-cell van-cell--clickable" @click="openFocus">
            <div class="van-cell__title">
                <span>关注公众号</span>
            </div>
            <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
        <!-- <div role="button" tabindex="0" class="van-cell van-cell--clickable" @click="openOrderForm">
            <div class="van-cell__title">
                <span>我的订单</span>
            </div>
            <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div> -->
        <div role="button" tabindex="0" class="van-cell van-cell--clickable" @click="openMobile">
            <div class="van-cell__title">
                <span>绑定手机号</span>
            </div>
            <span class="user-money" v-if="userInfo.phone">{{userInfo.phone}}&nbsp;&nbsp;</span>
            <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
        <div role="button" tabindex="0" class="van-cell van-cell--clickable"  @click="openIrt">
            <div class="van-cell__title">
                <span>关于</span>
            </div>
            <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
    </div>
    <van-goods-action v-if="userToken">
    <van-goods-action-button type="default" @click="outLogin" class="goods-go">退出登录</van-goods-action-button>
  </van-goods-action>
  <login-modal ref="login"/>
  </div>
</template>
<script>
import LoginModal from "@/components/LoginModal";
import {mapState} from "vuex";
import { Toast } from 'vant';
export default {
  name: 'personal',
  components: {
    LoginModal:LoginModal,
  },
  mounted () {
  },
  created() {
    this.getCouponCount()
  },
  data () {
    return {
      couponCount:0
    }
  },
  beforeDestroy() {
  
  },
  computed:{
      ...mapState(['personal'])
  },
  methods: {
    getCouponCount(){
      if(this.userToken){
        let data={
          // deviceNum:this.deviceNum
        }
        this.$api.coupon.getCouponCount(data).then(res=>{
          if(res.code==200){
            this.couponCount = res.couponCount
          }
        })
      }
    },
   openBalance(){
       if(this.userToken){
         this.$router.push({name: 'recharge'})
       }else{
        this.$refs.login.control()
       }
    },
    openFocus(){
      if(this.userToken){
        this.$router.push({
          name: 'focus'
        })
      }else{
        this.$refs.login.control()
      }
    },
    openCouponList() {
      if(this.userToken){
        this.$router.push({
          name: 'couponList'
        })
        // this.$router.push({
        //   name: 'coupon'
        // })
        // this.$router.push({
        //   name: 'focus'
        // })
      //  this.$router.push({
      //     name: 'lottery'
      //   })
        
       }else{
        this.$refs.login.control()
       }
    },
   openConsumption(){
       if(this.userToken){
        // Toast("暂未开放")
        this.$router.push({
          name: 'rechargeDetails', query: {type:2}
        })
       }else{
        this.$refs.login.control()
       }
   },
   openOrderForm(){
       if(this.userToken){
        // this.$router.push({name: 'orderForm'})
       }else{
        this.$refs.login.control()
       }
   },
   openMobile(){
       if(this.userToken){
        this.$router.push({name: 'mobile'})
       }else{
        this.$refs.login.control()
       }
   },
   openIrt(){
       Toast("暂未开放")
   },
   openHome(){
       this.$router.push({name: 'home'})
   },
   outLogin(){
    //退出登录    
    this.$store.dispatch('submitDelUserInfo')
    Toast("退出成功");
    this.$router.push({name: 'home'})
   },
   loginBtn(){
        let initData= {
            loginType:this.loginType,
            deviceNum:this.deviceNum
        }
        this.$api.login.loginInit(initData).then(res => {
            if(res.code==200){
               let redirect_uri =encodeURIComponent(res.redirect_uri), appid =res.appId
               this.goThere(this.loginType,appid,redirect_uri)
            }else{
               this.$router.push({name: 'nonsupport'})
            }
        })
   },
   goThere(loginType,appid,redirect_uri){
      if(loginType==2){
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"
      }else if(loginType==1){
          window.location.href = "https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id="+appid+"&scope=auth_user&redirect_uri="+redirect_uri
      }
   }
  }
}
</script>
<style lang="scss" scoped>
.comtainer-main{
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #f7f8fa;
    .bg-color{
        background-color: #15c466;
        width: 100%;
        height: 334px;
        .home-ico{
            padding: 25px 0 0 25px;
            display: inline-block;
            width: 40px;
        }
    }
    .user-info{
        position: relative;
        top:-200px;
        left: 25px;
        width: 700px;
        border-radius: 8px;
        background-color: #fff;
        box-shadow: 0 8px 12px #ebedf0;
        text-align: center;
        .box-user-info{
            height: 300px;
            z-index: 10;
            .user-img{
                border-radius:50% ;
                width: 160px;
                height: 160px;
                display: inline-block;
                position: relative;
                top: -60px;
                box-shadow: 0 8px 12px #ebedf0;
            }
            .user-name{
                position: relative;
                top: -30px;
                color: #333;
                font-weight:bold;
                font-size: 28px;
                .sex{
                    color:#666;
                    font-weight:normal;
                    font-size: 24px;
                }
            }
            .is-login{
                color: #666;
                position: relative;
                top: -20px;
                font-size: 24px;
            }
            .user-message{
                color: #666;
                position: relative;
                top: -20px;
                font-size: 24px;
            }
        }
    }
    .van-doc-demo-block__card{
        position: relative;
        top: -180px;
        box-shadow: 0 8px 12px #ebedf0;
        width: 700px;
        left: 25px;
        border-radius: 8px;
    }
    .user-money{
        color: #999;
    }

    .goods-go{
    height: 85px;
    background: #13A556 !important;
    color: #fff;
    border-radius: 14px;
    font-size:30px;
    margin:0 20px;
   }
    
}
</style>